import * as React from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	projectTemplatesRestCrudThunksForBuyer,
	projectTemplatesRestCrudThunksForSupplier,
} from '../../thunks/project_template_thunks';
import { Link } from 'react-router-dom';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import DeleteConfirmButton from '../delete_pop_confirm/DeletePopConfirm';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';

require('./ProjectTemplatesDetailPage.less');

interface ProjectTemplatesDetailPageState {}

interface ProjectTemplatesDetailPageProps {
	match: any;
}

class ProjectTemplatesDetailPage extends React.Component<any, ProjectTemplatesDetailPageState> {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const { getProjectTemplate, match, currentUser } = this.props;
		const projectTemplateId = match.params.id;
		const userType = nullSafeGetOrElse('userType', currentUser, 'buyer');
		getProjectTemplate(userType, projectTemplateId);
	}

	handleTabChange = (key) => {
		const { history, match, currentUser } = this.props;
		const projectTemplateId = match.params.id;
		const userType = nullSafeGetOrElse('userType', currentUser, 'buyer');
		history.push(`/${userType}/projects/templates/detail/${projectTemplateId}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleCopy = () => {
		const { history, match, location, currentUser } = this.props;
		const projectTemplateId = match.params.id;
		const userType = nullSafeGetOrElse('userType', currentUser, 'buyer');
		history.push(
			getLinkWIthBackLinkParams(
				location,
				'Back to project template',
				`/${userType}/projects/overview/templates/new?copyFromProjectTemplateId=${projectTemplateId}`
			)
		);
	};

	handleDelete = () => {
		const { history, deleteProjectTemplate, projectTemplate, currentUser } = this.props;
		const userType = nullSafeGetOrElse('userType', currentUser, 'buyer');
		deleteProjectTemplate(userType, projectTemplate).then(() => {
			history.push(`/${userType}/projects/overview/templates/overview`);
		});
	};

	render() {
		const { projectTemplate, projectTemplatesFetching, companyConfig, match, currentUser } =
			this.props;
		const projectTemplateId = match.params.id;
		const tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
		];
		const userType = nullSafeGetOrElse('userType', currentUser, 'buyer');
		return (
			<div>
				<DetailPageHeader
					exactPath={`/${userType}/projects/templates/detail/:id`}
					redirectPath={`/${userType}/projects/templates/detail/${projectTemplateId}/details`}
					backLinkText={'Back to Project Templates'}
					backLinkTo={`/${userType}/projects/overview/templates/overview`}
					title={projectTemplatesFetching ? null : projectTemplate.name}
					subtitle={null}
					actions={[
						<Link
							to={`/${userType}/projects/templates/edit/${projectTemplateId}`}
							style={{ marginRight: 16 }}
						>
							<Button ghost={true}>Edit</Button>
						</Link>,
						<Button ghost={true} onClick={this.handleCopy} style={{ marginRight: 16 }}>
							Copy and create new
						</Button>,
						<DeleteConfirmButton
							onConfirm={this.handleDelete}
							title={'Are you sure you want to delete this project template?'}
						>
							<Button ghost={true}>Delete</Button>
						</DeleteConfirmButton>,
					]}
					tabs={tabs}
					backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
					handleTabChange={this.handleTabChange}
					checkTabActive={this.checkTabActive}
					childRoutes={this.props.childRoutes}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	projectTemplatesFetching: state.project_templates.fetching,
	projectTemplate: state.project_templates.detail,
	companyConfig: state.company_config,
	match: ownProps.match,
	history: ownProps.history,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	getProjectTemplate: (userType, id) =>
		dispatch(
			userType === ROLE_TYPES.SUPPLIER
				? projectTemplatesRestCrudThunksForSupplier.readOne(id)
				: projectTemplatesRestCrudThunksForBuyer.readOne(id)
		),
	deleteProjectTemplate: (userType, entity) =>
		dispatch(
			userType === ROLE_TYPES.SUPPLIER
				? projectTemplatesRestCrudThunksForSupplier.delete(entity, 'id', null, true)
				: projectTemplatesRestCrudThunksForBuyer.delete(entity, 'id', null, true)
		),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(ProjectTemplatesDetailPage)
);
